export * from "modules/AppointmentDetails/components/VehicleTyres/components/TyreTable";
